import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_LOVE_BL: TStep[] = [
  {
    pageId: PageId.DOG_SEX_LOVE_BL,
  },
  {
    pageId: PageId.DOG_AGE_LOVE_BL,
  },
  {
    pageId: PageId.URGE_LOVE_BL,
  },
  {
    pageId: PageId.FEELINGS_LOVE_BL,
  },
  {
    pageId: PageId.URGE_1_LOVE_BL,
  },
  {
    pageId: PageId.TALKING_LOVE_BL,
  },
  {
    pageId: PageId.DOG_FOLLOW_LOVE_BL,
  },
  {
    pageId: PageId.LICKING_LOVE_BL,
  },
  {
    pageId: PageId.URGE_2_LOVE_BL,
  },
  {
    pageId: PageId.BEHAVIOR_LOVE_BL,
  },
  {
    pageId: PageId.FEEL_GUILTY_LOVE_BL,
  },
  {
    pageId: PageId.URGE_3_LOVE_BL,
  },
  {
    pageId: PageId.DOG_REACT_LOVE_BL,
  },
  {
    pageId: PageId.SATISFIED_LOVE_BL,
  },
  {
    pageId: PageId.BEHAVIOR_ISSUES_LOVE_BL,
  },
  {
    pageId: PageId.YOUR_REACTION_LOVE_BL,
  },
  {
    pageId: PageId.URGE_4_LOVE_BL,
  },
  {
    pageId: PageId.DOG_BREED_LOVE_BL,
  },
  {
    pageId: PageId.COMMANDS_LOVE_BL,
  },
  {
    pageId: PageId.DOG_NAME_LOVE_BL,
  },
  {
    pageId: PageId.LOVE_LOAD_SCREEN_BL,
  },
  {
    pageId: PageId.DOG_PROFILE_LOVE_BL,
  },
  {
    pageId: PageId.MOTIVATION_LOVE_BL,
  },
  {
    pageId: PageId.FEEL_DOG_LOVE_BL,
  },
  {
    pageId: PageId.FREQUENCY_LOVE_BL,
  },
  {
    pageId: PageId.PREPARE_FLOW_LOVE_BL,
  },
  {
    pageId: PageId.EMAIL_LOVE_BL,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_LOVE_BL,
  },
  {
    pageId: PageId.PERSONALIZED_PLAN_LOVE_BL,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_LOVE_BL,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_LOVE_BL,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_2_LOVE_BL,
  },
  {
    pageId: PageId.CANCEL_OFFER_LOVE_BL,
  },
  {
    pageId: PageId.CHAT_UPSELL_LOVE_BL,
  },
  {
    pageId: PageId.UPSELL_LOVE_BL,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_LOVE_BL,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_LOVE_BL,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_LOVE_BL,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_LOVE_BL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_LOVE_BL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
